import { Button, InputLabel, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generateLab } from '../actions/encodeActions'
import BackdropProgress from '../components/BackdropProgress'
import SEO from '../components/SEO'

function LabScreen() {

    const dispatch = useDispatch()
    const inputRef = useRef(null)

    const [input, setInput] = useState('')
    const [template, setTemplate] = useState('')

    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin

    const labState = useSelector(state => state.labReducer)
    const { labInProgress, labText } = labState

    const handleInputChange = (e) => {
        const val = e.target.value
        if (val.charAt(val.length-1) == ','){
            const lastIndex = val.lastIndexOf(',', val.length - 2)
            let input = ''
            if (lastIndex == -1) {
                input = val.substring(0, val.length-1)
            } else {
                input = val.substring(lastIndex + 1, val.length - 2)
            }
            const userId = (userInfo ? userInfo.id : -1)
            dispatch(generateLab(input, '', userId, 0))
        }
        setInput(val)
    }

    const handleTemplateChange = (e) => {
        setTemplate(e.target.value)
    }

    const handleGenerateLab = () => {
        const userId = (userInfo ? userInfo.id : -1)
        dispatch(generateLab(input, template, userId, 0))
    }

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.setSelectionRange(5,5)
        }
    })

    return (
        <>
            <SEO 
                title="PCR Lab - PCRAssist"
                description="Execute and monitor your PCR protocols in a virtual lab environment. Track progress and optimize your experiments in real-time."
                canonicalUrl="/lab"
            />
            <div>
                <h2>Shorthand Experiment</h2>
                <InputLabel>Type your shorthand here:</InputLabel>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    // value={input}
                    defaultValue={'This is a test'}
                    inputRef={inputRef}
                    // onChange={(e) => handleInputChange(e)}
                />
                <br/>
                <br/>
                <InputLabel>Template:</InputLabel>
                <TextField
                    fullWidth
                    multiline
                    rows={8}
                    value={template}
                    onChange={(e) => handleTemplateChange(e)}
                />
                <br/>
                <br/>
                <InputLabel>Generated PCR:</InputLabel>
                <TextField
                    fullWidth
                    multiline
                    disabled
                    rows={8}
                    value={labText}
                />
                <br/>
                <br/>
                <Button variant='contained' sx={{ height: 56 }} onClick={handleGenerateLab}>Generate</Button>

                { labInProgress ? <BackdropProgress /> : ''}
            </div>
        </>
    )
}

export default LabScreen